import { render, staticRenderFns } from "./IntoPage.vue?vue&type=template&id=d605d894&"
import script from "./IntoPage.vue?vue&type=script&lang=js&"
export * from "./IntoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports